import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { handleGraphQLErrors } from "../../../utils/handleGraphQLError";
import { EditableInformationStatus } from "../../SharedComponents/EditableInformation/EditableInformationStatus/EditableInformationStatus";
import { EditableInformationText } from "../../SharedComponents/EditableInformation/EditableInformationText/EditableInformationText";
import { ListLoading } from "../../SharedComponents/ListLoading/ListLoading";
import "./UserAccountDetails.css";

export const UserAccountDetails = ({ accountId }) => {
  const { t } = useTranslation();
  const { data, error, loading } = useQuery(getAccountsQuery, {
    variables: { id: accountId },
  });

  useEffect(() => {
    if (error) {
      handleGraphQLErrors(error);
    }
  }, [error]);

  return (
    <div className="UserAccountDetails">
      {loading && (
        <div style={{ width: "100%" }}>
          <ListLoading />
        </div>
      )}
      {!loading && (
        <div className="UserAccountDetails__content">
          <EditableInformationText
            label={t("generic.name")}
            name="Name"
            value={data?.account?.name}
            editable={false}
          />
          <EditableInformationText
            label={t("generic.email")}
            name="Email"
            value={data?.account?.email}
            editable={false}
          />
          <EditableInformationText
            label={t("accounts.address")}
            name="Address"
            value={data?.account?.address}
            editable={false}
          />
          <EditableInformationText
            label={t("accounts.postalCode")}
            name="Postal code"
            value={data?.account?.postalCode}
            editable={false}
          />
          <EditableInformationText
            label={t("accounts.country")}
            name="Country"
            value={data?.account?.country}
            editable={false}
          />
          <EditableInformationStatus
            label={t("generic.status")}
            name="Status"
            value={data?.account?.status}
            editable={false}
          />
        </div>
      )}
    </div>
  );
};

const getAccountsQuery = gql`
  query account($id: String) {
    account(id: $id) {
      id
      name
      email
      vat
      address
      postalCode
      country
      status
    }
  }
`;
